import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useLocation, createRestaurantSlug } from '../context/LocationContext';
import apiService from '../services/apiService';
import { KitchenCard, LoadingSpinner, EmptyState } from '../components';

const FavoritesPage = () => {
  const navigate = useNavigate();
  const { isAuthenticated } = useAuth();
  const { selectedLocation } = useLocation();
  const [favorites, setFavorites] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (!isAuthenticated) { navigate('/customer/login'); return; }
    loadFavorites();
  }, [isAuthenticated]);

  const loadFavorites = async () => {
    setIsLoading(true);
    try {
      const res = await apiService.getFavorites();
      const list = res?.data?.favorites || res?.data || [];
      setFavorites(Array.isArray(list) ? list : []);
    } catch (e) {}
    setIsLoading(false);
  };

  const handleRemoveFavorite = async (kitchenId) => {
    await apiService.removeFromFavorites(kitchenId);
    setFavorites(prev => prev.filter(f => (f.kitchen_id || f.id) !== kitchenId));
  };

  return (
    <div className="favorites-page">
      <div className="page-header">
        <h2 className="page-title">❤️ My Favorites</h2>
      </div>

      {isLoading ? (
        <LoadingSpinner text="Loading favorites..." />
      ) : favorites.length === 0 ? (
        <EmptyState
          icon="❤️"
          title="No favorites yet"
          subtitle="Save kitchens you love to find them quickly"
          action={{ label: 'Browse Kitchens', onClick: () => navigate('/customer') }}
        />
      ) : (
        <div className="kitchen-grid">
          {favorites.map(fav => {
            const kitchen = fav.kitchen || fav;
            const kid = kitchen.kitchen_id || kitchen.id;
            return (
              <KitchenCard
                key={kid}
                kitchen={kitchen}
                onClick={() => {
                  const kitchenSlug = createRestaurantSlug(kitchen.kitchen_name || kitchen.name) || kid;
                  const locSlug = selectedLocation?.slug;
                  navigate(locSlug ? `/customer/${locSlug}/${kitchenSlug}` : `/customer/kitchen/${kid}`);
                }}
                onFavorite={() => handleRemoveFavorite(kid)}
                isFavorite={true}
              />
            );
          })}
        </div>
      )}
    </div>
  );
};

export default FavoritesPage;
